import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const COL = { CONSEGNATA: "bg-emerald-500", SCARTATA: "bg-rose-500", MANCATA_CONSEGNA: "bg-amber-500" };

export const NotificheBell = () => {
  const [d, setD] = useState({ items: [], non_lette: 0 });
  const [open, setOpen] = useState(false);
  const seen = useRef(null);
  const nav = useNavigate();
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/notifiche");
      if (seen.current) data.items.filter((n) => !n.letta && !seen.current.has(n.id)).forEach((n) =>
        toast[n.stato === "SCARTATA" ? "error" : "success"](n.testo, { duration: 10000, action: { label: "Apri", onClick: () => { api.post("/notifiche/lette", { ids: [n.id] }).then(load).catch(() => {}); nav(`/app/fatture/${n.invoice_id}`); } } }));
      seen.current = new Set(data.items.map((n) => n.id));
      setD(data);
    } catch { /* offline o sessione scaduta: riprova al prossimo giro */ }
  }, [nav]);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  const apri = async (n) => {
    setOpen(false);
    if (!n.letta) { await api.post("/notifiche/lette", { ids: [n.id] }).catch(() => {}); load(); }
    nav(`/app/fatture/${n.invoice_id}`);
  };
  const tutte = async () => { await api.post("/notifiche/lette", { ids: [] }).catch(() => {}); load(); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid="notifiche-bell">
          <Bell className="h-5 w-5" />
          {d.non_lette > 0 && <span data-testid="notifiche-count" className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-600 px-1 text-[10px] font-bold text-white">{d.non_lette}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notifiche-panel">
        <div className="flex items-center justify-between border-b border-slate-100 px-3 py-2">
          <span className="text-sm font-semibold">Ricevute SdI</span>
          {d.non_lette > 0 && <button type="button" data-testid="notifiche-tutte-lette" className="text-xs text-sky-700 hover:underline" onClick={tutte}>Segna tutte lette</button>}
        </div>
        <ul className="max-h-80 overflow-y-auto">
          {d.items.length === 0 && <li className="px-3 py-4 text-sm text-slate-500">Nessuna ricevuta per ora.</li>}
          {d.items.map((n) => (
            <li key={n.id}>
              <button type="button" data-testid={`notifica-${n.id}`} onClick={() => apri(n)} className={`flex w-full gap-2 px-3 py-2 text-left text-sm transition-colors hover:bg-slate-50 ${n.letta ? "text-slate-500" : "font-medium text-slate-900"}`}>
                <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${COL[n.stato] || "bg-slate-400"}`} />
                <span className="min-w-0"><span className="block">{n.testo}</span><span className="block text-xs font-normal text-slate-400">{new Date(n.at).toLocaleString("it-IT")}</span></span>
              </button>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
};
